import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CButton, CFormTextarea } from '@coreui/react-pro'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import Logo from 'src/assets/Logo.svg'
import AILogo from 'src/assets/BlueLogo.svg'
import {
  getReason,
  postCensusConvo,
  postMessageCensusConvo,
  setChargeClaimStatus,
  setStatus,
} from '../../../../helper/backendHelper'
import { clearSidePanel } from '../../../../redux/sidePanel/sidePanelSlice'
import { COLLECTOR_URL } from '../../../../apiHelper/apiRoute/collector'
import { getCollector } from '../../../../apiHelper/collectorApi'
import { getIsAi } from '../../../../utils/sharedFeaturesFunctions'
import { VISIT_STATUS } from '../../../../utils/statusConstants'

async function getHoldData(panelEncounter, onSuccess) {
  const url = COLLECTOR_URL.GET_PATIENT_HOLD_DATA.replace('{patientId}', panelEncounter.patient_id)
  const holdDataResponse = await getCollector(url)
  const holdData = holdDataResponse.data?.find((datum) => datum?._id === panelEncounter?._id)

  let convoId = null
  let res = await postCensusConvo(panelEncounter._id)
  if (res?.status === 'success') {
    convoId = res?.conversation_id
  }

  const taskstatus_id = panelEncounter?.taskstatus_id
  let finalArr = []
  try {
    if (taskstatus_id) {
      let res = await getReason(taskstatus_id)
      if (res?.status === 'success') {
        for (let i = 0; i < holdData?.reason_codes?.length; i++) {
          const reason = holdData?.reason_codes[i]
          const found = res?.data[0]?.reason_code?.find((rc) => rc?.code_title === reason)
          if (found) {
            finalArr?.push(found)
          }
        }
      }
    }
  } catch (e) {
    toast.error('Unable to get provider hold reason(s)')
  }

  onSuccess({
    convoId,
    comments: [...(holdData?.comments || []).filter((item) => item?.comment_internal === false)],
    reason_codes_final: finalArr,
    reason_codes: holdData?.reason_codes,
    taskstatus_id: holdData?.taskstatus_id,
    // hold_date: holdData?.hold_date,
  })
}

export default function PanelHoldCard() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const userId = useSelector((state) => state?.user?.user?._id)

  const encounterId = useSelector((state) => state.sidePanel.panelEncounter?._id)
  const panelEncounter = useSelector((state) => state.sidePanel.panelEncounter)

  const [holdData, setHoldData] = useState(null)
  const [text, setText] = useState('')

  const sendMessage = async () => {
    const currentUserId = userId
    let data = {
      message_text: text,
      user_id: currentUserId,
      message_type: 1,
      conversation_id: holdData?.convoId,
    }
    let res = await postMessageCensusConvo(holdData?.convoId, data)
    if (res?.status === 'success') {
      let data = {
        charge_id: encounterId,
        newStatus: '5a1e7d8ff7c5f4ebba3f503c',
        parentStatus: 'Provider Hold',
        parent_assigned_userid: currentUserId,
        status: 'Response Received',
        taskid: panelEncounter?.references?.task_id,
      }
      let statusRes = await setStatus(data, panelEncounter?.references?.task_id)
      if (statusRes?.status === 'success') {
        let chargeData = {
          charge_ids: [encounterId],
          newStatus: VISIT_STATUS.bill_submitted,
        }
        let chargeClaimStatus = await setChargeClaimStatus(chargeData)
        if (chargeClaimStatus?.status === 'success') {
          toast.success('The message has been sent.')
          dispatch(clearSidePanel())
        }
      }
    }
  }

  useEffect(() => {
    if (panelEncounter && !holdData) {
      getHoldData(panelEncounter, setHoldData)
    }
  }, [panelEncounter, holdData])

  return (
    <div id={'PanelHoldCard'}>
      <div className="messaging">
        <div>
          {holdData?.reason_codes_final?.length === 0 &&
            (holdData?.comments?.length === 0 || !holdData?.comments) && (
              <p className="noResult">No Result</p>
            )}
          {holdData?.reason_codes_final &&
            holdData?.reason_codes_final.map((reasons, index) => (
              <div className="providerHoldReasons" key={index}>
                <div className="left">
                  <div className={'hold-exclaim'}>!</div>
                </div>
                <div className="right">
                  <div className="title">{reasons?.code_title}</div>
                  <div className="reason">{reasons?.code_description}</div>
                </div>
              </div>
            ))}
          {holdData?.comments &&
            holdData?.comments.map((comment, index) => (
              <div className="providerHoldReasons" key={index}>
                <div className="left">
                  <span>
                    <i className="fa-sharp fa-regular fa-message fa-flip-horizontal"></i>
                  </span>
                </div>
                <div className="right">
                  <div className="title">{comment?.comment_text}</div>
                </div>
              </div>
            ))}
        </div>
      </div>
      <div className="claimocity-support-modal new-message">
        <div>
          <img src={getIsAi() ? AILogo : Logo} alt="Claimocity Logo" />
          Claimocity Billing
        </div>
        <hr />
        <div>
          <CFormTextarea
            rows={7}
            className="form-text-area"
            onChange={(e) => setText(e.target.value)}
            value={text}
          />
        </div>
        <div className={'hold-button-row'}>
          <CButton
            color="secondary"
            onClick={() => {
              dispatch(clearSidePanel())
              navigate('/messages')
            }}
          >
            Go to messages
          </CButton>
          <CButton
            color="primary"
            className="send-message"
            disabled={text?.trim()?.length === 0}
            onClick={() => sendMessage()}
          >
            Send message
          </CButton>
        </div>
      </div>
    </div>
  )
}
